import { PREFIX } from '../../constants';

const generateMaskControlAttributes = ({ controlName }) => {
    return {
        [`${PREFIX}${controlName}MaskShape`]: {
            type: 'string',
            default: 'none'
        },
        [`${PREFIX}${controlName}MaskSize`]: {
            type: 'string',
            default: 'auto'
        },
        [`${PREFIX}${controlName}MaskPosition`]: {
            type: 'string',
            default: 'center center'
        },
        [`${PREFIX}${controlName}MaskRepeat`]: {
            type: 'string',
            default: 'no-repeat'
        }
    };
};

export default generateMaskControlAttributes;
